import {combineReducers} from 'redux';
import * as a from './actionTypes'

function ALL_ROLES_BY_APP_KEY(state = [], action) {
    switch (action.type) {
        case a.ALL_ROLES_BY_APP_KEY:
            return action.data;
        default:
            return state;
    }
}

function SSO_ATTRIBUTE_TYPES(state = [], action) {
    switch (action.type) {
        case a.SELF_REGISTRATION_ATTRIBUTE_TYPES:
            return action.data;
        default:
            return state;
    }
}

function ULTIMATE_PARENT_COMPANY_ALLOWED_ROLES(state = [], action) {
    switch (action.type) {
        case a.ULTIMATE_PARENT_COMPANY_ALLOWED_ROLES:
            return action.data ? action.data : state;
        default:
            return state;
    }
}

function ULTIMATE_PARENT_COMPANY(state = {}, action) {
    switch (action.type) {
        case a.ULTIMATE_PARENT_COMPANY:
            return action.data ? action.data : state;
        default:
            return state;
    }
}

function PERSONAL_INFO(state = {}, action) {
    switch (action.type) {
        case a.USER_INPUT_PERSONAL_INFO_CHANGE:
            return action.data;
        default:
            return state;
    }
}

function SELF_REGISTRATION_SETTINGS(state = {}, action) {
    switch (action.type) {
        case a.SELF_REGISTRATION_SETTINGS:
            return action.data;
        default:
            return state;
    }
}

function BRAND_CONFIG(state = null, action) {
    switch (action.type) {
        case a.BRAND_CONFIG_RECEIVED:
            // Apps without a BRAND_CONFIG app setting return a success with no payload;
            // combineReducers rejects undefined, so fall back to the default theme.
            return action.data !== undefined ? action.data : null;
        default:
            return state;
    }
}

function REGISTRATION_SESSION_ACTIVE(state = false, action) {
    switch (action.type) {
        case a.REGISTRATION_SESSION_ACTIVE:
            return action.data;
        default:
            return state;
    }
}

export default combineReducers(
    {
        PERSONAL_INFO,
        ALL_ROLES_BY_APP_KEY,
        ULTIMATE_PARENT_COMPANY_ALLOWED_ROLES,
        ULTIMATE_PARENT_COMPANY,
        SELF_REGISTRATION_SETTINGS,
        SSO_ATTRIBUTE_TYPES,
        BRAND_CONFIG,
        REGISTRATION_SESSION_ACTIVE
    }
)
